import React from 'react'
import { componentConstructor } from '../../GUIConstructor/control'
import { AdjustableRange } from './AdjustableRange/AdjustableRange'
import { BlockModels } from './types'

export const blockConstructor = ({
    dataSchema,
    data,
    dataProp,
    name,
    childrenPath,
    dataPath,
    blockState,
    builderType,
    levelDeep = 1,
    element_id,
    inCard,
    isRuleActive,
    pathWithElementID
}: {
    dataSchema: any,
    data: any,
    dataProp: any,
    name: string,
    childrenPath: string,
    dataPath: string,
    pathWithElementID: string | undefined,
    blockState: boolean,
    builderType: 'actionUiBuilder' | 'configUiBuilder',
    levelDeep: number,
    element_id?: string,
    inCard?: boolean,
    isRuleActive?: boolean,
}) => {
    switch (dataSchema?.model) {
        case BlockModels.ADJUSTABLE_RANGE:
            return (
                <AdjustableRange
                    blockState={blockState}
                    childrenPath={childrenPath}
                    dataProp={dataProp}
                    data={data}
                    dataSchema={dataSchema}
                    name={name}
                    dataPath={dataPath}
                    levelDeep={levelDeep + 1}
                    element_id={element_id}
                    inCard={inCard}
                    isRuleActive={isRuleActive}
                    pathWithElementID={pathWithElementID}
                    builderType={builderType}
                />
            )

        default:
            return componentConstructor({
                path: childrenPath,
                ProductScheme: dataSchema,
                ProductConfiguration: Object.keys(data || {}).length ? data : dataProp,
                name,
                builderType,
                wrapper: 'block',
                classname: '',
                isParentDisabled: !blockState,
                levelDeep: levelDeep + 1,
                element_id,
                inCard,
                isRuleActive,
                pathWithElementID,
            })
    }
}
